
import { Market } from "../../classes"
import Helper from "../../plugins/Helper/Helper"
import Store from "../../store"
const MarketModule = {
  namespaced: true,
  state: () => ({
    markets: [],
    isLoading: false,
    currentMarket: null
  }),
  actions: {
    getMarketByProject: async ({ commit, dispatch }, payload) => {
      try {
        let user = Store.getters['user/getUser']
        commit("setIsLoading", true);
        commit("setMarkets", []);
        const data = await Market.getMarketByProject({ projectId: payload }, user ? user : null);
        commit("setMarkets", data);
        commit("setIsLoading", false);
        return data
      } catch (err) {
        commit("setIsLoading", false);
        throw err
      }
    },
  },
  getters: {
    // getMarketCount: (state) => state.market?.areas?.length,
    // getMarketName: (state) => state.market?.market?.name,
    // getProjectId: (state) => state?.projectId,
    getMarkets: (state) => state.markets,
    getIsLoading: state => state.isLoading,
  },
  mutations: {
    clearMarket: (state) => {
      state.markets = [];
      state.isLoading = false;
      state.currentMarket = null;
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setMarkets: (state, markets) => {
      state.markets = markets || [];
    },
    setCurrentMarket: (state, payload) => {
      state.currentMarket = payload.currentMarket;
    },
  },
};
export default MarketModule;

